import script from "./TermsOfUseView.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfUseView.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfUseView.vue?vue&type=style&index=0&id=77953c2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77953c2d"]])

export default __exports__